import { createContext, useContext } from 'react';
import { OrganizationRole } from '@dsgvo-buddy/types';

export interface UserRoleContextType {
  organizationRole: OrganizationRole | null;
  canCreate: boolean;
  canEdit: boolean;
  canApprove: boolean;
  canDelete: boolean;
  isOwner: boolean;
}

export const UserRoleContext = createContext<UserRoleContextType>({
  organizationRole: null,
  canCreate: false,
  canEdit: false,
  canApprove: false,
  canDelete: false,
  isOwner: false,
});

export function useUserRole(): UserRoleContextType {
  return useContext(UserRoleContext);
}

export function computePermissions(role: string | null | undefined): UserRoleContextType {
  const orgRole = (role as OrganizationRole) || null;
  const isOwner = orgRole === OrganizationRole.OWNER;
  const isAdmin = orgRole === OrganizationRole.ADMIN;
  const isMember = orgRole === OrganizationRole.MEMBER;

  return {
    organizationRole: orgRole,
    canCreate: isOwner || isAdmin || isMember,
    canEdit: isOwner || isAdmin || isMember,
    canApprove: isOwner || isAdmin,
    canDelete: isOwner || isAdmin,
    isOwner,
  };
}
